import { render } from "./homeStudioDetail.vue?vue&type=template&id=bf0fc09a&scoped=true"
import script from "./homeStudioDetail.vue?vue&type=script&lang=js"
export * from "./homeStudioDetail.vue?vue&type=script&lang=js"

import "./homeStudioDetail.vue?vue&type=style&index=0&id=bf0fc09a&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf0fc09a"]])

export default __exports__